import { useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ContactCards from "./components/ContactCards";
import FAQSection from "./components/FAQSection";
import ContactForm from "./components/ContactForm";

export default function Support() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-28 pb-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20dark%20network%20grid%20pattern%20with%20glowing%20nodes%2C%20dark%20background%20technology%20concept%2C%20deep%20space%20digital%20art%2C%20subtle%20geometric%20grid%20lines%2C%20minimal%20dark%20backdrop&width=1440&height=400&seq=support_bg&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-4">{t("support.hero_title")}</h1>
          <div className="relative">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />
            <input
              type="text"
              placeholder={t("support.hero_placeholder")}
              className="w-full bg-white rounded-xl pl-11 pr-5 py-3.5 text-sm text-gray-800 outline-none"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </section>

      <ContactCards />

      <div className="pt-14">
        <FAQSection />
        <ContactForm />
      </div>

      <Footer />
    </div>
  );
}
